import { connect } from 'react-redux'
import sidebarSelector from './sidebarSelector'
import { sagaActions } from '../sagas'
import { sagaActions as rootSagaActions } from 'store/sagas'
import Sidebar from './Sidebar'
import {
  setIsSidebarVisible
} from 'store/redux/layout'

export default connect(
  sidebarSelector,
  {
    fetchBoardTile: rootSagaActions.fetchBoardTile,
    requestPositionLayout: sagaActions.requestPositionLayout,
    setIsSidebarVisible,
  }
)(Sidebar)
